import { validateCountry } from "@/providers/Localization";
const regex = {
  phoneNumber: /^\+?[0-9]{1,3}[-. (]?[0-9]{1,3}[-. )]?[0-9]{1,4}[-. ]?[0-9]{1,4}[-. ]?[0-9]{1,9}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

const validationRules = {
  string(input: string, { minLength = 0, maxLength = null }: { minLength?: number; maxLength?: number | null }): boolean {
    return [typeof input === "string", maxLength !== null ? input.length <= maxLength : true, input.length > minLength].every(
      (x) => x
    );
  },
  number(input: number, { minValue = null, maxValue = null }: { minValue?: number | null; maxValue?: number | null }): boolean {
    return [
      typeof input === "number",
      minValue !== null ? input >= minValue : true,
      maxValue !== null ? input <= maxValue : true,
    ].every((x) => x);
  },
  phoneNumber(input: string): boolean {
    return typeof input === "string" && regex.phoneNumber.test(input);
  },
  email(input: string): boolean {
    return typeof input === "string" && regex.email.test(input);
  },
  postalCode(input: string): boolean {
    return typeof input === "string";
  },
  vatNumber(input: string): boolean {
    return typeof input === "string";
  },
  country(input: string): boolean {
    return validateCountry(input);
  },
};

function validate(
  type: keyof typeof validationRules,
  {
    value,
    isTouched = false,
    required = false,
  }: {
    value: string | number;
    isTouched: boolean;
    required?: boolean;
  },
  additionalValidationProps?: {} | undefined
) {
  if (isTouched) {
    // Check for required and no value
    if (required && value === "") return false;
    // Otherwise treat as normal input
    else {
      if (typeof value === "string" && value.length > 0) {
        return (validationRules[type] as (input: string, additionalValidationProps: {} | undefined) => boolean)(
          value,
          additionalValidationProps ?? {}
        )
          ? true
          : false;
      }
      if (typeof value === "number" && !isNaN(value)) {
        return (validationRules[type] as (input: number, additionalValidationProps: {} | undefined) => boolean)(
          value,
          additionalValidationProps ?? {}
        )
          ? true
          : false;
      }
    }
  }
  return true;
}

export { validate };
